<div class="tables-layout">
  <div class="tables-layout__configuration-section"> 
    <div class="tables-layout__reservation-data content-summary"
    [ngStyle]="{'background-color':ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderBackgroundColor,
    'color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
        <div style="width: 100%;">
          <span class="tables-layout__guest-info-text" [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
            {{partyDetails.partySize}} {{'party' | translate}} </span>
          <span class="tables-layout__guest-info-text" [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
            {{partyDetails.reservationTime | formatSettingsDate:ls.restaurantWidgetSettings$.value.DateFormat}}</span>
          <span class="tables-layout__guest-info-text" [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
            {{partyDetails.seatingArea.name | translate}}</span>
          <span class="tables-layout__guest-info-text" [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
            {{partyDetails.seatingType.name | translate}}</span>
          <span class="tables-layout__guest-info-text" [ngStyle]="{'border-right-color': ls.restaurantWidgetSettings$.value.WidgetCustomization.SubheaderTextColor}">
            {{partyDetails.reservationTime| formatSettingsDate:'LT'}}</span>
        </div>
        <div style="padding: 0 12px;">
          <app-button [buttontype]="editButton" (valueChange)="getReservationDetails()"></app-button>
        </div>
      </div>


  </div>
  <div class="tables-layout__canvas-view" #canvasLoader>
    <!-- <ng-scrollbar [trackX]="true">   -->
    <canvas id="tablesLayout" #tablesLayout></canvas>
    <!-- </ng-scrollbar> -->

  </div>
  <div class="tables-layout__actions">
    <app-button [buttontype]="previousButton" (valueChange)="getReservationDetails()"></app-button>
    <app-button [buttontype]="nextButton" (valueChange)="getGuestDetails()"></app-button>
  </div>
</div>